(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gemstone-recomdation"] && !Shopify.designMode) return;
  try {
    
  var dialCode = '+91',
    phone,
    ajaxMessage = '.ajax-message',
    phoneNumber,
    otpNumber = '3456',
    sendOtp = true,
    submitBtn = $('.rudraksh').find('[type=submit]');
  var FORM_STORAGE_KEY = 'brahmagems_form_draft';

  function saveFormToStorage() {
    var $form = $('#ajax-form');
    if (!$form.length) return;
    var fullPhone = '';
    try {
      if ($('.phone-intl').length) fullPhone = $('.phone-intl').intlTelInput('getNumber') || '';
    } catch (e) {}
    if (!fullPhone) fullPhone = dialCode + ($('[name="phone"]').val() || '');
    var data = {
      name: $form.find('[name="name"]').val() || '',
      email: $form.find('[name="email"]').val() || '',
      phone: fullPhone || '',
      date_of_birth: $form.find('[name="date_of_birth"]').val() || '',
      time_of_birth: $form.find('[name="time_of_birth"]').val() || '',
      place_of_birth: $form.find('[name="place_of_birth"]').val() || '',
    };
    try {
      localStorage.setItem(FORM_STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function loadFormFromStorage() {
    var saved;
    try {
      saved = localStorage.getItem(FORM_STORAGE_KEY);
      if (!saved) return;
      saved = JSON.parse(saved);
    } catch (e) {
      return;
    }
    var $form = $('#ajax-form');
    if (!$form.length) return;
    if (saved.name) $form.find('[name="name"]').val(saved.name);
    if (saved.email) $form.find('[name="email"]').val(saved.email);
    if (saved.date_of_birth) $form.find('[name="date_of_birth"]').val(saved.date_of_birth);
    if (saved.time_of_birth) $form.find('[name="time_of_birth"]').val(saved.time_of_birth);
    if (saved.place_of_birth) $form.find('[name="place_of_birth"]').val(saved.place_of_birth);
    if (saved.phone && $('.phone-intl').length) {
      try {
        $('.phone-intl').intlTelInput('setNumber', saved.phone);
      } catch (e) {
        $form.find('[name="phone"]').val(saved.phone.replace(/^\+\d+/, ''));
      }
    }
  }

  $('.phone-intl')
    .intlTelInput({
      initialCountry: 'in',
      separateDialCode: true,
    })
    .on('countrychange', function (e, countryData) {
      dialCode = '+' + $(this).intlTelInput('getSelectedCountryData').dialCode;
    });

  $(function () {
    loadFormFromStorage();
  });

  $('body').on('input change', '#ajax-form input', function () {
    saveFormToStorage();
  });

  document.addEventListener('DOMContentLoaded', function () {
    const inputs = document.querySelectorAll('#otp > input');
    for (let i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener('input', function () {
        if (this.value.length > 1) {
          this.value = this.value[0]; //
        }
        if (this.value !== '' && i < inputs.length - 1) {
          inputs[i + 1].focus(); //
        }
        getOTPNumber();
      });

      inputs[i].addEventListener('keydown', function (event) {
        if (event.key === 'Backspace') {
          this.value = '';
          if (i > 0) {
            inputs[i - 1].focus();
          }
        }
        getOTPNumber();
      });
    }

    function getOTPNumber() {
      otpNumber = '';
      inputs.forEach((input) => {
        otpNumber += input.value;
      });
    }
  });

  $('[name="phone"]').on('keyup', function () {
    let value = $(this).val(
      $(this)
        .val()
        .replace(/^0*(.+)/, '$1')
    );
    if (phoneNumber == $(this).val() && phoneNumber != '') {
      sendOtp = true;
      submitBtn.val('Verify OTP & Get Recommendation');
    } else {
      submitBtn.val('Submit');
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    const dobInput = document.querySelector('[name="date_of_birth"]');
    const today = new Date().toISOString().split('T')[0];
    dobInput.max = today;
  });

  $('#ajax-form').validate({
    rules: {
      phone: {
        required: true,
      },
      name: {
        required: true,
      },
      email: {
        required: true,
        email: true,
      },
      gender: {
        required: true,
      },
      purpose: {
        required: true,
      },
      body_weight: {
        required: true,
      },
      budget: {
        required: true,
      },
      time_of_birth: {
        required: true,
      },
      date_of_birth: {
        required: true,
      },
      place_of_birth: {
        required: true,
      },
    },
    messages: {
      name: 'Please enter name',
      phone: 'Please enter phone number',
      time_of_birth: 'Please enter time of birth ',
      date_of_birth: 'Please enter date of birth ',
      place_of_birth: 'Please enter place of birth ',
      gender: 'Please enter gender. ',
      purpose: 'Please select purpose. ',
      body_weight: 'Please enter body weight. ',
      budget: 'Please select budget. ',
      email: {
        required: 'Please registered email id',
        email: 'Please enter valid email id',
      },
    },
    errorPlacement: function (error, element) {
      var placement = $(element).data('error');
      if (placement) {
        $(placement).html(error);
      } else {
        error.insertAfter(element);
      }
    },
    submitHandler: function (form) {
      $(this).find('[type=submit]').attr('disabled', '');
      let formdata = new FormData(form);
      formdata.append('phone_code', dialCode);
      formdata.append('otp', otpNumber);
      formdata.append('current_url', window.location.href);
      let phone = $('[name="phone"]').val();

      if (dialCode == '+91') {
        if (phone.length != 10) {
          $('.ajax-message').html('<div class="alert alert-danger">Please enter 10 digits phone number.</div>');
          return false;
        }
      } else {
        if (phone.length > 15) {
          $('.ajax-message').html('Please enter valid phone number.');
          return false;
        } else if (phone.length < 2) {
          $('.ajax-message').html('Please enter valid phone number.');
          return false;
        }
      }

      // if (phoneNumber != phone) {
      //     sendOtp = false;
      // }

      phoneNumber = phone;

      $.ajax({
        url: 'https://api.brahmagems.com/shopify/brahmagems/' + (sendOtp ? 'verify' : 'send') + '-otp',
        type: 'POST',
        data: formdata,
        contentType: false,
        processData: false,
        beforeSend: function () {
          $(ajaxMessage).html(
            '<div class="alert alert-success"><i class="fa fa-refresh fa-spin"></i> Please wait... </div>'
          );
        },
        success: function (res) {
          var apiGems = res.data && res.data.gems ? res.data.gems : [];
          var userName = res.data && res.data.name ? res.data.name : '';
          const gemLabels = [
            'HEALTHY STONE',
            'BENEFITS STONE',
            'LUCKY STONE', // For all remaining gems beyond index 2
          ];
          fetch(window.recommendationUrl)
            .then(function (resp) {
              return resp.json();
            })
            .then(function (themeGems) {
              var byHandle = {};
              (themeGems || []).forEach(function (g) {
                if (g && g.handle) byHandle[g.handle] = g;
              });
              var indexNumber = 0;
              var merged = apiGems
                .map(function (apiGem) {
                  var handle = apiGem.handle || (apiGem.gem_key || '').replace(/_/g, '-');
                  var theme = byHandle[handle];
                  if (!theme) return null;
                  return {
                    name: `${gemLabels[indexNumber++]}: ${theme.name}`,
                    image: theme.image,
                    url: theme.url,
                    wear_day: apiGem.wear_day,
                  };
                })
                .filter(Boolean);
              localStorage.setItem('gems', JSON.stringify(merged));
              localStorage.setItem('name', userName);
              showRecommendation();
            })
            .catch(function () {
              localStorage.setItem('gems', JSON.stringify(apiGems));
              localStorage.setItem('name', userName);
              showRecommendation();
            });
          // $(ajaxMessage).html('<div class="alert alert-success">' + res.message + '</div>');
          // $(".otp-box").show();
          // submitBtn.val('Verify OTP & Get Recommendation');
          // if(sendOtp){
          //   submitBtn[0].reset();
          // }
          // submitBtn[0].reset();
          // sendOtp = true;
        },
        complete: function () {
          submitBtn.removeAttr('disabled');
          setTimeout(function () {
            $(ajaxMessage).html('');
          }, 20000);
        },
        error: function (error) {
          let data = JSON.parse(error.responseText);
          if (error.status === 422) {
            var errorString = '<ul class="ps-3 m-0">';
            $.each(data.errors, function (key, value) {
              errorString += '<li>' + value + '</li>';
            });
            errorString += '</ul>';
            response = errorString;
          } else {
            response = data.error;
          }

          $(ajaxMessage).html('<div class="alert alert-danger">' + response + '</div>');
        },
      });
      return false;
    },
  });

  var DEFAULT_HEADING_HTML = 'Know your <b>Gemstone</b>';

  $('body').on('click', '.edit-form', function (e) {
    e.preventDefault();
    $('#recommendations-view').hide();
    $('#form-view').show();
    var heading = document.getElementById('dynamic-heading');
    if (heading) heading.innerHTML = DEFAULT_HEADING_HTML;
  });

  function showRecommendation() {
    let gems = localStorage.getItem('gems');
    let name = localStorage.getItem('name');

    if (!gems || !name) return;

    // ✅ HEADING REPLACE HERE
    const heading = document.getElementById('dynamic-heading');
    if (heading) {
      heading.innerHTML = `
          Hello <strong>${name}</strong> !<br>
          <span style="font-size:14px; font-family:Montserrat,sans-serif;">
            Here are your recommended gemstones
            <a href="#" class="edit-form ms-2">Edit details</a>
          </span>
        `;
    }

    $('#form-view').hide();
    gems = JSON.parse(gems);

    // function showRecommendation() {
    //     let gems = localStorage.getItem('gems');
    //     let name = localStorage.getItem('name');

    //     if (!gems) return;

    //     $("#ajax-form").hide();

    //     gems = JSON.parse(gems);

    let recommendation = ``;

    //         recommendation += `
    //   <p class="text-center">
    //     Hello <strong>${name}</strong> ! <br>
    //     Here are your recommended gemstones.
    //     <a href="#" class="edit-form fs-sm ms-2">Edit details</a>
    //   </p>
    // `;

    // recommendation += `<p class="text-center">Hello <b>${name}</b>, here are your recommended gems. &nbsp;&nbsp;&nbsp;&nbsp;<a href="" class="edit-form fs-sm">Edit details</a></p> `;
    recommendation += `<div class="row g-4 d-none d-md-flex">`;

    Object.values(gems).forEach((gem) => {
      // FIXED HERE
      recommendation += `
                <div class="col-6 col-md-4 text-center">
                    <a href="${gem.url}" class="category-item">
                        <div class="category-image">
                            <img src="${gem.image}" alt="${gem.name}" loading="lazy">
                        </div>
                        <p class="category-title">${gem.name}</p>
                        <p class="wear-text">Wear: ${gem.wear_day}</p>
                    </a>
                </div>
            `;
    });

    recommendation += `</div>`;

    $('#recommendations-view').html(recommendation).show();
  }

  showRecommendation();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() { document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) requestAnimationFrame(this.reveal.bind(this));
        else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() { if (!this.headerIsAlwaysSticky) { this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky'); this.closeMenuDisclosure(); this.closeSearchModal(); } }
    reveal() { if (!this.headerIsAlwaysSticky) { this.header.classList.add('shopify-section-header-sticky', 'animate'); this.header.classList.remove('shopify-section-header-hidden'); } }
    reset() { if (!this.headerIsAlwaysSticky) this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate'); }
    closeMenuDisclosure() { this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu'); this.disclosures.forEach(disclosure => disclosure.close()); }
    closeSearchModal() { this.searchModal = this.searchModal || this.header.querySelector('details-modal'); this.searchModal.close(false); }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["the-jewel"] && !Shopify.designMode) return;
  try {
    

  // Nav scroll
  const nav = document.getElementById('mainNav');
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 60);
  });

  // Reveal on scroll
  const reveals = document.querySelectorAll('.reveal');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
  reveals.forEach(el => observer.observe(el));

  // Gem rings (reattach animations after layout)
  document.querySelectorAll('.orbit-circle').forEach((el, i) => {
    const durations = [25, 40, 60];
    el.style.animation = `slowRotate ${durations[i]}s linear ${i % 2 === 1 ? 'reverse' : ''} infinite`;
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', async function () {

  const container = document.getElementById('product-grid');

  if (!container) return;

  let wishlistItems = [];

  try {
    wishlistItems = Wishlist.get();
  } catch (e) {
    console.log('Wishlist library missing');
  }

  // ── HELPER: header count sync ──
  // Aapke header mein: <div class="wishlist-count-bubble hidden wishlist-count"><span>0</span></div>
  // span ke andar number hai, hidden class toggle hoti hai div pe
  function syncHeaderCount() {
    const count = Wishlist.get().length;

    document.querySelectorAll('.wishlist-count').forEach(function(el) {
      // span child update karo (aapke header ka structure)
      const span = el.querySelector('span');
      if (span) {
        span.innerText = count;
      } else {
        el.innerText = count;
      }
      // hidden class toggle
      el.classList.toggle('hidden', count === 0);
    });
  }

  // EMPTY
  if (!wishlistItems || wishlistItems.length === 0) {
    container.innerHTML = `
      <div id="wishlist-empty">
        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
        </svg>
        <h2>Your Wishlist is Empty</h2>
        <p>Start adding products you love.</p>
      </div>
    `;
    return;
  }

  container.innerHTML = '';

  // LOOP PRODUCTS
  for (const handle of wishlistItems) {
    try {

      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) continue;

      const product = await response.json();

      let image = '';
      if (product.featured_image) {
        image = product.featured_image;
      } else if (product.images && product.images.length > 0) {
        image = product.images[0];
      }

      const variant   = product.variants[0];
      const variantId = variant.id;
      const sku       = variant.sku || 'N/A';
      const origin    = product.vendor || 'SRI LANKA';
      const price     = '₹' + (product.price / 100).toLocaleString('en-IN');

      const li = document.createElement('li');
      li.className = 'grid__item';

      li.innerHTML = `
        <div class="wishlist-card">
          <div class="wishlist-image-wrapper">
            <a href="/products/${product.handle}">
              <img
                class="wishlist-image"
                src="${image}&width=800"
                alt="${product.title}"
                loading="lazy"
              >
            </a>
          </div>
          <div class="wishlist-content">
            <h3 class="wishlist-title">
              <a href="/products/${product.handle}">${product.title.toUpperCase()}</a>
            </h3>
            <div class="wishlist-meta">SKU: ${sku} | ORIGIN: ${origin}</div>
            <div class="wishlist-price">${price}</div>
            <div class="wishlist-buttons">
              <button class="add-cart" data-id="${variantId}">Add To Cart</button>
              <button class="remove-wishlist" data-handle="${product.handle}">Remove</button>
            </div>
          </div>
        </div>
      `;

      container.appendChild(li);

    } catch (error) {
      console.log(error);
    }
  }

  // ADD TO CART
  document.querySelectorAll('.add-cart').forEach(function(button) {
    button.addEventListener('click', async function () {
      const id = this.dataset.id;
      this.innerText = 'Adding...';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        });
        if (response.ok) {
          this.innerText = 'Added ✓';
          setTimeout(() => { window.location.href = '/cart'; }, 700);
        } else {
          this.innerText = 'Error';
        }
      } catch(err) {
        console.log(err);
        this.innerText = 'Error';
      }
    });
  });

  // REMOVE PRODUCT
  document.querySelectorAll('.remove-wishlist').forEach(function(button) {
    button.addEventListener('click', function () {

      const handle = this.dataset.handle;

      // Wishlist.toggle use karo — same as global JS mein hai
      Wishlist.toggle(handle);

      // card hatao
      this.closest('.grid__item').remove();

      // header count sync — span + hidden class dono
      syncHeaderCount();

      // heart button ka active state bhi hatao (product pages pe)
      document.querySelectorAll(
        `.wishlist-btn[data-handle="${handle}"]`
      ).forEach(function(btn) {
        btn.classList.remove('active');
      });

      // agar khaali ho gayi wishlist toh reload
      if (Wishlist.get().length === 0) {
        location.reload();
      }

    });
  });

});


  } catch(e) { console.error(e); }
})();
})();
